
import { FilterOption } from '../../components/layouts-live-stream/ToggleFilter/ToggleFilter';
import { ILiveStream } from '../../types';


export const filterEventsByType = (events: ILiveStream[], option: FilterOption) => {
    switch (option) {
        case 'Free':
            return events.filter(e => !e.isPrivate);
        case 'Premium':
            return events.filter(e => e.isPrivate);
        default:
            return events;
    }
};
